<template>
  <div class="">
    <!--    <div class="md-layout-item md-size-100">-->
    <!--      <md-field>-->
    <!--        <label>Name on Card</label>-->
    <!--        <div id="card-name"></div>-->
    <!--      </md-field>-->
    <!--    </div>-->
    <!--    <div class="md-layout-item md-size-75">-->
    <!--      <md-field>-->
    <!--        <label>Card Number</label>-->
    <!--        <div id="card-number"></div>-->
    <!--      </md-field>-->
    <!--    </div>-->
    <!--    <div class="md-layout-item md-size-25">-->
    <!--      <md-field>-->
    <!--        <label>CVC</label>-->
    <!--        <div id="card-cvc"></div>-->
    <!--      </md-field>-->
    <!--    </div>-->
    <!--    <div-->
    <!--      class="md-layout-item md-size-50 md-xsmall-size-50 md-small-size-50 md-medium-size-33 md-large-size-33 md-xlarge-size-33"-->
    <!--    >-->
    <!--      <md-field>-->
    <!--        <label>Expiry Month</label>-->
    <!--        <div id="card-expiry"></div>-->
    <!--      </md-field>-->
    <!--    </div>-->
    <!--    <div-->
    <!--      class="md-layout-item md-size-100 md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-large-size-33 md-xlarge-size-33"-->
    <!--    >-->
    <!--      <img :src="require('@/assets/icons/credit-card-icons.svg')" />-->
    <!--    </div>-->
    <div class="md-layout-item p-3">
      <label for="payment-element">Cardholder Name</label>
      <input
        id="card-holder-name"
        v-model="cardHolderName"
        type="text"
      /><br /><br />

      <label for="payment-element">Card Details</label>
      <!--Stripe.js injects the Payment Element-->
      <div id="payment-element"></div>
      <div id="payment-error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api";

export default {
  name: "CreditCardTable",
  data() {
    return {
      error: "",
      cardHolderName: "",
      payElement: null,
      stripe: null
    };
  },
  mounted() {
    this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
    const elements = this.stripe.elements();
    this.payElement = elements.create("card");
    this.payElement.mount("#payment-element");
  },
  methods: {
    async createPayMethodId() {
      this.error = "";

      // this.stripe.createPaymentMethod({
      //     type: "card",
      //     card: this.payElement,
      //     billing_details: { name: this.cardHolderName }
      //   }).then(function(result) {
      //     console.log(result)
      //   });

      const setupIntentSecret = (await ApiService.user.getSetupIntent()).data
        .data.secret;

      const stripeResult = await this.stripe.confirmCardSetup(
        setupIntentSecret,
        {
          payment_method: {
            card: this.payElement,
            billing_details: { name: this.cardHolderName }
          }
        }
      );

      if (stripeResult.error) {
        // handle error here
        this.error = stripeResult.error.message;
        this.$toast.error(stripeResult.error.message);

        throw new Error(stripeResult.error.message);
      }

      return stripeResult.setupIntent.payment_method;
    }
  }
};
</script>

<style lang="css" scoped>
#payment-element,
#card-holder-name {
  width: 100%;
  padding: 12px;
  border: 1px solid lightgray;
  border-radius: 10px;
}
</style>
